import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';

export default function ChallengeCard({ challenge, onComplete, loading }) {
  return (
    <div
      data-testid={`challenge-${challenge.id}`}
      className={`p-4 rounded-xl border-2 transition-all hover-lift ${
        challenge.completed
          ? 'bg-green-50 border-green-300'
          : 'bg-white border-gray-200 hover:border-purple-300'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-3xl">{challenge.icon}</span>
            <div>
              <h4 className="font-semibold text-gray-900">{challenge.title}</h4>
              <p className="text-sm text-gray-600">{challenge.description}</p>
            </div>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <span className="text-xs font-semibold px-2 py-1 bg-purple-100 text-purple-700 rounded-full">
              +{challenge.xp} XP
            </span>
          </div>
        </div>
        {challenge.completed ? (
          <div className="bg-green-500 text-white rounded-full p-2">
            <Check className="w-5 h-5" />
          </div>
        ) : (
          <Button
            data-testid={`complete-${challenge.id}-btn`}
            onClick={() => onComplete(challenge.id)}
            disabled={loading}
            size="sm"
            className="hover-grow"
          >
            {loading ? 'Tamamlanıyor...' : 'Tamamla'}
          </Button>
        )}
      </div>
    </div>
  );
}